import { getAll } from '../../utils/api';
import { services } from '../../constants/services';

export interface InitDataDto {
  user: UserDto;
  userRoles: UserRoleDto[];
  rolePermissions: RolePermissionDto[];
}

export interface UserDto {
  id: string;
  name: string;
  lastName: string;
  avatarUrl: string;
  email: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export interface RoleDto {
  id: string;
  name: string;
  description: string;
  isActive: number;
  isSuperAdmin: boolean | null;
  deletedAt: string | null;
}

export interface UserRoleDto {
  id: string;
  userId: string;
  roleId: string;
  role: RoleDto;
}

export interface PermissionDto {
  id: string;
  name: string;
  description: string;
  route: string;
  icon: string | null;
  cssClass: string | null;
  order: number;
  isActive: number;
}

export interface RolePermissionDto {
  id: string;
  roleId: string;
  permissionId: string;
  permissions: PermissionDto;
}

export const GetInitDataService = async () => {
  const response:any = await getAll<InitDataDto>(`${services.users}/init-data`);
  return response.data;
};
